import ModalComp from 'components/Modal';
import CenteredWrapper from 'pages/updatePassword/CenteredWrapper';
import { FormControlLabel, Radio, RadioGroup, Stack, InputLabel } from '@mui/material';
import Input from 'components/Input';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CustomButton from 'components/Button';
import SaveIcon from '@mui/icons-material/Save';
import { useSelector } from 'react-redux';
import { authPostRequest, getAuthRequest } from 'Api/api';
import SuccessError from 'components/SuccessError';
import Loader from 'components/Loader';
import { checkIsProductNameValid, isStringEmpty } from 'utils/utils';
import { useEffect } from 'react';
import { style } from 'constant/constants';
import ErrorForSelect from 'components/ErrorForSelect';
import { removeReadOnly } from 'reduxStore/authSlice';
import { useDispatch } from 'react-redux';

const InputFeilds = [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    maxLength: 149,
    placeholder: 'Enter roof section name',
    required: true
  },

  {
    name: 'description',
    label: 'Description',
    type: 'text',
    maxLength: 499,
    placeholder: 'Enter roof section description',
    required: true
  }
];
const CreateRoofSection = ({
  openModal,
  setOpenModal,
  setSuccess,
  setAlertBar,
  setIsFormSaved,
  isFormSaved,
  projectId,
  projectName,
  projectDescription
}) => {
  const [roofSection, setRoofSection] = useState({
    name: '',
    description: ''
  });
  const [quotaion, setQuotation] = useState([]);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [errors, setErrors] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [showAlertBar, setShowAlertBar] = useState(false);
  const { userData } = useSelector((store) => store.auth);
  const [errorMessage, setErrorMessage] = useState([]);
  const [isEmptyCalType, setEmptyCalType] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  //Input Handler
  const handleproject = (e) => {
    setRoofSection({ ...roofSection, [e.target.name]: e.target.value });
    handleError(e.target.name, null);
  };

  const handleQuotaion = (e) => {
    const selectedIndex = parseInt(e.target.value);
    setSelectedQuotation(quotaion[selectedIndex]);
    setEmptyCalType(false);
  };

  const handleError = (input, errorMessage) => {
    setErrors((prevState) => ({ ...prevState, [input]: errorMessage }));
  };

  const validateRoofSection = () => {
    const isEmptyName = isStringEmpty(roofSection.name);
    if (isEmptyName) {
      handleError('name', 'Please enter name');
    }
    const isEmptyDescription = isStringEmpty(roofSection.description);
    if (isEmptyDescription) {
      handleError('description', 'Please enter description ');
    }
    const nameCheck = checkIsProductNameValid(roofSection.name);
    if (nameCheck) {
      handleError('name', 'Please do not use special characters in name ');
    }

    if (selectedQuotation?.id == null || selectedQuotation?.id == undefined) {
      setEmptyCalType(true);
    }

    if (
      !isEmptyName &&
      !isEmptyDescription &&
      !nameCheck &&
      isEmptyCalType == false &&
      selectedQuotation?.id != null
    ) {
      setErrors({});
      return true;
    }

    return false;
  };

  const getQuotationTypes = async () => {
    try {
      setShowLoader(true);
      const roofTypes = await getAuthRequest('getQuotationTypes');
      setQuotation(roofTypes);
      setShowLoader(false);
    } catch (err) {
      return err;
    }
  };
  useEffect(() => {
    getQuotationTypes();
  }, []);

  //connect with save API
  const submitHandler = async (e) => {
    e.preventDefault();
    setAlertBar(false);
    setShowAlertBar(false);
    setSuccess([]);
    setErrorMessage([]);

    setShowLoader(true);
    const validRoofSection = validateRoofSection();

    const requestParams = {
      userId: userData.userId,
      projectId: projectId,
      name: roofSection.name?.trim(),
      description: roofSection.description?.trim(),
      quotationTypeId: selectedQuotation?.id
    };

    const createRoofSection =
      validRoofSection && (await authPostRequest('saveRoofSection', requestParams));
    if (createRoofSection) {
      setAlertBar(true);
      setShowAlertBar(true);
      if (createRoofSection.resStatus === 1) {
        dispatch(removeReadOnly());
        setSuccess([createRoofSection.resMessage]);
        setOpenModal(false);
        setIsFormSaved(!isFormSaved);

        selectedQuotation.name === 'Snow Bracket' &&
          navigate('/StoreInfo/calculator', {
            state: {
              roofData: {
                id: createRoofSection.objectId,
                name: roofSection.name,
                description: roofSection.description
              },
              projectId: projectId,
              projectName: projectName,
              projectDescription: projectDescription
            }
          });
        selectedQuotation.name === 'Snow Fence' &&
          navigate('/StoreInfo/calculator-fence', {
            state: {
              roofData: {
                id: createRoofSection.objectId,
                name: roofSection.name,
                description: roofSection.description
              },
              projectId: projectId,
              projectName: projectName,
              projectDescription: projectDescription
            }
          });

        localStorage.removeItem('visited');

        setRoofSection({
          name: '',
          description: ''
        });
      } else {
        setErrorMessage([createRoofSection.resMessage]);
      }
    }
    setShowLoader(false);
  };

  return (
    <CenteredWrapper>
      <ModalComp
        modalWidth={400}
        open={openModal}
        setOpen={setOpenModal}
        header="Create Roof Section">
        {showAlertBar && (
          <SuccessError errorMessage={errorMessage} setShowAlertBar={setShowAlertBar} />
        )}
        {showLoader && <Loader open={showLoader} />}

        <form onSubmit={submitHandler}>
          <InputLabel
            htmlFor="demo-simple-select-label"
            sx={{
              fontFamily: style.fontFamily,
              color: style.LIGHT.primary,
              marginLeft: '5vh',
              marginTop: 2,
              marginBottom: -2
            }}
            className="text-menu-color-green">
            Select Calculator Type<span className="text-red-600"> *</span>
          </InputLabel>
          <RadioGroup
            sx={{ ml: '5vh', mt: '1vh', marginBottom: -1.3 }}
            row
            aria-label="quotation"
            name="quotation"
            value={selectedQuotation ? quotaion.indexOf(selectedQuotation).toString() : ''}
            onChange={handleQuotaion}>
            {quotaion.map((quotation, index) => (
              <FormControlLabel
                key={index}
                value={index.toString()}
                control={<Radio />}
                label={quotation.name}
              />
            ))}
          </RadioGroup>
          {isEmptyCalType && (
            <ErrorForSelect style={{ marginTop: '-1.3vh', marginLeft: '5vh' }}>
              Please select calculator type
            </ErrorForSelect>
          )}
          {InputFeilds.map(({ name, type, placeholder, label, required, maxLength }) => (
            <Stack key={name} direction="row" sx={{ marginTop: '3vh' }}>
              <Input
                type={type}
                placeholder={placeholder}
                onChange={handleproject}
                value={roofSection[name]}
                required={required}
                maxLength={maxLength}
                label={label}
                onFocus={() => handleError(name, null)}
                name={name}
                error={errors[name]}
              />
            </Stack>
          ))}
          <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ mr: '5vh' }}>
            <CustomButton
              sx={{ ml: '15vh' }}
              type="submit"
              onClick={submitHandler}
              endIcon={<SaveIcon />}>
              Save
            </CustomButton>
          </Stack>
        </form>
      </ModalComp>
    </CenteredWrapper>
  );
};

CreateRoofSection.propTypes = {
  openModal: PropTypes.bool,
  isFormSaved: PropTypes.bool,
  projectId: PropTypes.number,
  setIsFormSaved: PropTypes.func,
  setOpenModal: PropTypes.func,
  setSuccess: PropTypes.func,
  setAlertBar: PropTypes.func,
  projectName: PropTypes.string,
  projectDescription: PropTypes.string
};
export default CreateRoofSection;
